import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/cms/brands/logo-77.svg")